module.exports = __webpack_public_path__ + "no-image.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/no-image.png
// module id = 30
// module chunks = 0